import { useState, useEffect } from "react";
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { NativeSelect } from "@/components/ui/native-select";
import { API } from "@/App";
import axios from "axios";
import { Truck, Plus, AlertTriangle } from "lucide-react";
import { STATUS_ROMANEIO, fmtDataBR, fmtHora } from "./constants";

export default function RomaneiosPage() {
  const [romaneios, setRomaneios] = useState([]);
  const [alertas, setAlertas] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/logistica/romaneios${filtro ? `?status=${filtro}` : ""}`),
      axios.get(`${API}/logistica/alertas`),
    ]).then(([r, a]) => { setRomaneios(r.data); setAlertas(a.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [filtro]);

  return (
    <MainLayout>
      <div className="space-y-4" data-testid="romaneios-page">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <h1 className="text-2xl font-bold text-luvcorp-navy flex items-center gap-2">
              <Truck className="h-6 w-6 text-luvcorp-gold" /> Romaneios de Entrega (FL-05)
            </h1>
            <p className="text-sm text-slate-500">Numeração anual da Logística · 1ª via fica na obra, 2ª volta assinada</p>
          </div>
          <Button onClick={() => (window.location.href = "/logistica/nova-saida")} className="bg-luvcorp-navy text-white" data-testid="btn-nova-saida">
            <Plus className="h-4 w-4 mr-1" /> Nova saída para obra
          </Button>
        </div>

        {alertas.map((a, i) => (
          <div key={i} data-testid={`alerta-logistica-${a.tipo}`}
            className={`flex items-start gap-2 rounded-lg border p-3 text-sm ${a.gravidade === "alta" ? "bg-red-50 border-red-300 text-red-800" : "bg-amber-50 border-amber-300 text-amber-800"}`}>
            <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
            <span>{a.mensagem}</span>
          </div>
        ))}

        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-600">Situação:</span>
          <NativeSelect value={filtro} onValueChange={setFiltro} className="w-56" data-testid="filtro-status-romaneio"
            placeholder="Todas"
            options={[{ value: "", label: "Todas" }, ...Object.entries(STATUS_ROMANEIO).map(([k, v]) => ({ value: k, label: v.label }))]} />
        </div>

        <Card className="border-0 shadow-sm">
          <CardContent className="p-0 overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-luvcorp-navy text-white text-left">
                  <th className="px-3 py-2.5 font-semibold">Nº</th>
                  <th className="px-3 py-2.5 font-semibold">Obra</th>
                  <th className="px-3 py-2.5 font-semibold">Entrega</th>
                  <th className="px-3 py-2.5 font-semibold hidden md:table-cell">Veículo / Condutor</th>
                  <th className="px-3 py-2.5 font-semibold hidden md:table-cell">Itens</th>
                  <th className="px-3 py-2.5 font-semibold">Situação</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={6} className="px-3 py-8 text-center text-slate-400">Carregando…</td></tr>
                ) : romaneios.length === 0 ? (
                  <tr><td colSpan={6} className="px-3 py-8 text-center text-slate-400">Nenhum romaneio. Crie a primeira saída para obra.</td></tr>
                ) : romaneios.map((r) => {
                  const st = STATUS_ROMANEIO[r.status] || {};
                  return (
                    <tr key={r.id} className="border-b border-slate-100 hover:bg-slate-50 cursor-pointer"
                      data-testid={`romaneio-row-${r.numero}`}
                      onClick={() => (window.location.href = `/logistica/romaneios/${r.id}`)}>
                      <td className="px-3 py-2.5 font-bold text-luvcorp-navy whitespace-nowrap">{r.numero}</td>
                      <td className="px-3 py-2.5">{r.obra_titulo}<div className="text-xs text-slate-400">{r.cliente_nome}</div></td>
                      <td className="px-3 py-2.5 whitespace-nowrap">{fmtDataBR(r.data_entrega)}
                        {r.hora_saida_base && <div className="text-xs text-slate-400">Saída {fmtHora(r.hora_saida_base)}</div>}</td>
                      <td className="px-3 py-2.5 hidden md:table-cell">{r.veiculo_placa} · {r.condutor_nome}</td>
                      <td className="px-3 py-2.5 hidden md:table-cell">{(r.linhas || []).length}</td>
                      <td className="px-3 py-2.5"><Badge variant="outline" className={st.cls}>{st.label || r.status}</Badge></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
}
